import { FC } from 'react';
import { PageButton } from './PageButton';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageClick: (page: number) => void;
};

export const Pagination: FC<PaginationProps> = ({ currentPage, totalPages, onPageClick }) => {
  if (totalPages < 1 || isNaN(totalPages)) return null;

  const getPageNumbers = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const isNearBeginning = currentPage < 4;
    const isNearEnd = currentPage > totalPages - 3;

    if (isNearBeginning) {
      return [1, 2, 3, 4, '...', totalPages - 1, totalPages];
    }

    if (isNearEnd) {
      return [1, 2, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }

    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
  };

  const pageNumbers = getPageNumbers();

  return (
    <>
      <div className='shrink-0 text-sm text-secondary-700 md:hidden'>
        Page {currentPage} of {totalPages}
      </div>
      <ul data-page={currentPage} aria-label='Pagination' className='group/pagination hidden gap-0.5 md:flex'>
        {pageNumbers.map((page, index) => (
          <PageButton key={typeof page === 'number' ? page : `dots-${index}`} page={page} isCurrent={page === currentPage} onClick={onPageClick} />
        ))}
      </ul>
    </>
  );
};
